import { FormEvent, useEffect, useState } from 'react';
import { authzApi, type Role } from '../../api/authz';

export function RoleAssignmentPage() {
  const [roles, setRoles] = useState<Role[]>([]);
  const [userId, setUserId] = useState('');
  const [roleId, setRoleId] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    void authzApi.listRoles().then(setRoles).catch((err) => setError(String(err)));
  }, []);

  async function onAssign(e: FormEvent) {
    e.preventDefault();
    setError('');
    setMessage('');
    try {
      await authzApi.assignRole(userId, roleId);
      setMessage(`Role assigned to ${userId}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Assignment failed');
    }
  }

  async function onRevoke() {
    setError('');
    setMessage('');
    try {
      await authzApi.revokeRole(userId, roleId);
      setMessage(`Role revoked from ${userId}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Revoke failed');
    }
  }

  return (
    <div className="mx-auto max-w-3xl p-6">
      <h1 className="text-2xl font-semibold text-slate-900">Role assignment</h1>
      <p className="mt-1 text-sm text-slate-600">Assign or revoke roles for identity users.</p>
      {error && <p className="mt-4 rounded-lg bg-red-50 p-3 text-sm text-red-700">{error}</p>}
      {message && <p className="mt-4 rounded-lg bg-green-50 p-3 text-sm text-green-700">{message}</p>}

      <form onSubmit={onAssign} className="mt-6 space-y-4 rounded-xl border border-slate-200 bg-white p-6">
        <label className="block text-sm">
          User ID
          <input required value={userId} onChange={(e) => setUserId(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2" />
        </label>
        <label className="block text-sm">
          Role
          <select required value={roleId} onChange={(e) => setRoleId(e.target.value)} className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2">
            <option value="">Select role…</option>
            {roles.map((r) => (
              <option key={r.id} value={r.id}>{r.name}</option>
            ))}
          </select>
        </label>
        <div className="flex gap-3">
          <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-white">Assign role</button>
          <button type="button" onClick={() => void onRevoke()} className="rounded-lg border border-slate-300 px-4 py-2">Revoke role</button>
        </div>
      </form>
    </div>
  );
}
